export class OpenAPIPath {
    rawPath;
    params;
    constructor(rawPath, params) {
        this.rawPath = rawPath;
        this.params = params;
    }
    buildUrl() {
        return OpenAPIPath.setPathParams(this.rawPath, this.params);
    }
    static setPathParams(path, params) {
        const asEntries = Object.entries(params ?? {});
        const finalPath = asEntries.reduce((path, entry) => {
            const [key, value] = entry;
            return path.replace(`{${key}}`, encodeURIComponent(value));
        }, path);
        return finalPath.startsWith("/") ? finalPath.substring(1) : finalPath;
    }
}
export default OpenAPIPath;
